import React from 'react'
import './Section5.css'
import pointer from '../../static/page1-img/pointer.svg';

function Section5() {
  // Removed useState and toggle logic since only one job is displayed
  return (
    <div className='section5' id='section_experience'>
      <div className='section5__1'>
        <p>Where I've Worked</p>
      </div>
      <div className='section5__2'>
        <div className='section5__2__left'>
          {/* Only display the current job title */}
          <div className='section5__2__left__content'>
            <p className='activeJob' id="job_1">TCS</p>
          </div>
        </div>

        {/* Display the current job details (TCS) */}
        <div className='section5__2__right'>
          <div className='section5__2__right__first'>
            <p>Java Developer <span>@Tata Consultancy Services</span></p>
            <span>December 2023 - Present</span>
          </div>
          
          <div className='section5__2__right__second'>
            <img src={pointer} alt="" />
            <p>
              Engineered and deployed a Spring Boot-based monitoring dashboard for the DBA team, enabling real-time surveillance of legacy database activities.
            </p>
          </div>
          
          <div className='section5__2__right__third'>
            <img src={pointer} alt="" />
            <p>
              Developed an automated Spring Boot solution for deploying JavaScript files across Oracle DB servers, reducing application downtime by over 50%.
            </p>
          </div>

        </div>

      </div>
    </div>
  )
}

export default Section5